import { render, staticRenderFns } from "./AppError.vue?vue&type=template&id=86487a14&scoped=true&"
var script = {}
import style0 from "./AppError.vue?vue&type=style&index=0&id=86487a14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_@babel+core@7.28.5_supports-color@9.4.0____98dfd1e4490f4915d683750b41a85eda/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86487a14",
  null
  
)

export default component.exports